/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */
// Configuration
const COUNT_FORMATS = [
  {
    // 0 - 99999
    letter: '',
    limit: 1e5
  },
  {
    // 1,00,000 - 99,99,999
    letter: 'L',
    limit: 1e7
  },
  {
    // 1,00,00,000 - 99,99,99,999
    letter: 'Cr',
    limit: 1e9
  },
  {
    // 100,00,00,000
    letter: 'Ar',
    limit: 1e11
  }
];

// Format Method:
function formatCount(value) {
  const format = COUNT_FORMATS.find((format) => value < format.limit);

  value = (1000 * value) / format.limit;
  value = Math.round(value * 10) / 100; // keep one decimal number, only if needed

  return value + format.letter;
}

const currencyFormat = (n, short, symbol) => {
  let v = parseFloat(n);
  if (n < 0) {
    v = n * -1;
  }
  if (n !== null) {
    if (symbol) {
      if (short && v > 99999) {
        return `₹ ${n < 0 ? '-' : ''}${formatCount(v)}+`;
      }
      return `₹ ${n < 0 ? '-' : ''} ${new Intl.NumberFormat('en-IN').format(v)}`;
    }
    return `${n < 0 ? '-' : ''} ${new Intl.NumberFormat('en-IN').format(v)}`;
  }
  return 'N/A';
};

export default currencyFormat;
